export default "__VITE_ASSET__Dlh0SkXn__"